/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Backend API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { BasicDataDimensions } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { DataDimensionSearchRequest } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
/**
 * NonSourceabilityControllerApi - axios parameter creator
 */
export const NonSourceabilityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accepts lists of company IDs, frameworks, and reporting periods. Returns the set of (companyId, dataType, reportingPeriod) triples for which an active non-sourceability entry exists and that match any combination of the provided filters. An empty list for any field is treated as a wildcard and matches all values for that dimension.
         * @summary Returns all currently-active non-sourceability data dimensions matching the given filters.
         * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchNonSourceableDimensions: async (dataDimensionSearchRequest: DataDimensionSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataDimensionSearchRequest' is not null or undefined
            assertParamExists('searchNonSourceableDimensions', 'dataDimensionSearchRequest', dataDimensionSearchRequest)
            const localVarPath = `/non-sourceable/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataDimensionSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts lists of company IDs, frameworks, and reporting periods. Returns the set of (companyId, dataType, reportingPeriod) triples for which an active non-sourceability entry exists and that match any combination of the provided filters, pre-grouped into a map of maps: companyId -> framework -> set of matching data dimensions. An empty list for any field is treated as a wildcard and matches all values for that dimension.
         * @summary Returns all currently-active non-sourceability data dimensions matching the given filters, grouped by company ID and framework.
         * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchNonSourceableDimensionsGroupedByCompanyAndFramework: async (dataDimensionSearchRequest: DataDimensionSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataDimensionSearchRequest' is not null or undefined
            assertParamExists('searchNonSourceableDimensionsGroupedByCompanyAndFramework', 'dataDimensionSearchRequest', dataDimensionSearchRequest)
            const localVarPath = `/non-sourceable/search/grouped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataDimensionSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NonSourceabilityControllerApi - functional programming interface
 */
export const NonSourceabilityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NonSourceabilityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Accepts lists of company IDs, frameworks, and reporting periods. Returns the set of (companyId, dataType, reportingPeriod) triples for which an active non-sourceability entry exists and that match any combination of the provided filters. An empty list for any field is treated as a wildcard and matches all values for that dimension.
         * @summary Returns all currently-active non-sourceability data dimensions matching the given filters.
         * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchNonSourceableDimensions(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<BasicDataDimensions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchNonSourceableDimensions(dataDimensionSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonSourceabilityControllerApi.searchNonSourceableDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts lists of company IDs, frameworks, and reporting periods. Returns the set of (companyId, dataType, reportingPeriod) triples for which an active non-sourceability entry exists and that match any combination of the provided filters, pre-grouped into a map of maps: companyId -> framework -> set of matching data dimensions. An empty list for any field is treated as a wildcard and matches all values for that dimension.
         * @summary Returns all currently-active non-sourceability data dimensions matching the given filters, grouped by company ID and framework.
         * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchNonSourceableDimensionsGroupedByCompanyAndFramework(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: { [key: string]: Set<BasicDataDimensions>; }; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchNonSourceableDimensionsGroupedByCompanyAndFramework(dataDimensionSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonSourceabilityControllerApi.searchNonSourceableDimensionsGroupedByCompanyAndFramework']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NonSourceabilityControllerApi - factory interface
 */
export const NonSourceabilityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NonSourceabilityControllerApiFp(configuration)
    return {
        /**
         * Accepts lists of company IDs, frameworks, and reporting periods. Returns the set of (companyId, dataType, reportingPeriod) triples for which an active non-sourceability entry exists and that match any combination of the provided filters. An empty list for any field is treated as a wildcard and matches all values for that dimension.
         * @summary Returns all currently-active non-sourceability data dimensions matching the given filters.
         * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchNonSourceableDimensions(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Set<BasicDataDimensions>> {
            return localVarFp.searchNonSourceableDimensions(dataDimensionSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts lists of company IDs, frameworks, and reporting periods. Returns the set of (companyId, dataType, reportingPeriod) triples for which an active non-sourceability entry exists and that match any combination of the provided filters, pre-grouped into a map of maps: companyId -> framework -> set of matching data dimensions. An empty list for any field is treated as a wildcard and matches all values for that dimension.
         * @summary Returns all currently-active non-sourceability data dimensions matching the given filters, grouped by company ID and framework.
         * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchNonSourceableDimensionsGroupedByCompanyAndFramework(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: { [key: string]: Set<BasicDataDimensions>; }; }> {
            return localVarFp.searchNonSourceableDimensionsGroupedByCompanyAndFramework(dataDimensionSearchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NonSourceabilityControllerApi - interface
 */
export interface NonSourceabilityControllerApiInterface {
    /**
     * Accepts lists of company IDs, frameworks, and reporting periods. Returns the set of (companyId, dataType, reportingPeriod) triples for which an active non-sourceability entry exists and that match any combination of the provided filters. An empty list for any field is treated as a wildcard and matches all values for that dimension.
     * @summary Returns all currently-active non-sourceability data dimensions matching the given filters.
     * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchNonSourceableDimensions(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Set<BasicDataDimensions>>;

    /**
     * Accepts lists of company IDs, frameworks, and reporting periods. Returns the set of (companyId, dataType, reportingPeriod) triples for which an active non-sourceability entry exists and that match any combination of the provided filters, pre-grouped into a map of maps: companyId -> framework -> set of matching data dimensions. An empty list for any field is treated as a wildcard and matches all values for that dimension.
     * @summary Returns all currently-active non-sourceability data dimensions matching the given filters, grouped by company ID and framework.
     * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchNonSourceableDimensionsGroupedByCompanyAndFramework(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: { [key: string]: Set<BasicDataDimensions>; }; }>;

}

/**
 * NonSourceabilityControllerApi - object-oriented interface
 */
export class NonSourceabilityControllerApi extends BaseAPI implements NonSourceabilityControllerApiInterface {
    /**
     * Accepts lists of company IDs, frameworks, and reporting periods. Returns the set of (companyId, dataType, reportingPeriod) triples for which an active non-sourceability entry exists and that match any combination of the provided filters. An empty list for any field is treated as a wildcard and matches all values for that dimension.
     * @summary Returns all currently-active non-sourceability data dimensions matching the given filters.
     * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchNonSourceableDimensions(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig) {
        return NonSourceabilityControllerApiFp(this.configuration).searchNonSourceableDimensions(dataDimensionSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts lists of company IDs, frameworks, and reporting periods. Returns the set of (companyId, dataType, reportingPeriod) triples for which an active non-sourceability entry exists and that match any combination of the provided filters, pre-grouped into a map of maps: companyId -> framework -> set of matching data dimensions. An empty list for any field is treated as a wildcard and matches all values for that dimension.
     * @summary Returns all currently-active non-sourceability data dimensions matching the given filters, grouped by company ID and framework.
     * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchNonSourceableDimensionsGroupedByCompanyAndFramework(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig) {
        return NonSourceabilityControllerApiFp(this.configuration).searchNonSourceableDimensionsGroupedByCompanyAndFramework(dataDimensionSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

